import { render, staticRenderFns } from "./JobOrderList.vue?vue&type=template&id=0c1ad752&"
import script from "./JobOrderList.vue?vue&type=script&lang=js&"
export * from "./JobOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports